import { connect } from 'react-redux';
import SetupLoaderModal from './setupLoaderModal';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(SetupLoaderModal);
